import { API_BASE } from "./_fetch";

export function getReportDownloadUrl(downloadPath: string): string {
  if (/^https?:\/\//.test(downloadPath)) return downloadPath;

  const path = downloadPath.startsWith("/") ? downloadPath : `/${downloadPath}`;
  const accessPrefix = "/reports/access/";
  if (path.startsWith(accessPrefix)) {
    return `https://ishvaram.com/r/${encodeURIComponent(path.slice(accessPrefix.length))}`;
  }
  return `${API_BASE}${path}`;
}
